<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Contatti</li>
            </ul>
            <h2>Contattaci</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class="courses-details-image">
    <img  src="assets/img/university-contatti.jpg"  style="max-height:550px; width:100%; object-fit: cover;  object-position: bottom bottom;" alt="image">
</div>

<div class="contact-area ptb-100">
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Chi siamo</span>
                    <h2>Fondazione Ampioraggio</h2>
                    <p>
                        nasce nel 2016 a Salerno con l’obiettivo di creare un ecosistema nazionale di innovazione, unendo Nord e Sud Italia e superando gli ostacoli che da sempre limitano l’incontro tra l’offerta di innovazione (startup e centri di ricerca) e la domanda (pubblica e privata), ottenendo il riconoscimento giuridico come fondazione di partecipazione nel 2022.
                    </p>
                    <p>
                        Fondazione Ampioraggio nasce nel 2016 a Salerno con l’obiettivo di creare un ecosistema nazionale di innovazione, unendo Nord e Sud Italia e superando gli ostacoli che da sempre limitano l’incontro tra l’offerta di innovazione (startup e centri di ricerca) e la domanda (pubblica e privata), ottenendo il riconoscimento giuridico come fondazione di partecipazione nel 2022.
                    </p>
                    <p>
                        Nel 2017 lancia il format JAZZ’INN, un evento di slow dating che riunirà per 5 giorni a fine luglio (miracolosamente, ma siamo a Pietrelcina il paese di San Pio) centinaia di attori del settore da tutta Italia, facendoli immergere tra riunioni informali alla ricerca di idee e momenti conviviali, a base di aglianico e serate di grande jazz.
                        Il risultato di quelle giornate si traduce in una serie di ricadute economiche progressive, nell’incremento del pubblico jazz e nell’aumento della permanenza media delle persone nel borgo, con un impatto sull’economia locale.
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">i nostri eventi</span>
                    <h2>Un vero e proprio format</h2>
                    <p>
                        In 6 anni l’evento diventa un vero e proprio format, capace di generare milioni di euro di ricadute economiche, diventare strumento di coesione territoriale, trasformando un borgo in uno smart village e sperimentando modelli di sviluppo sostenibile nati tra i tavoli di lavoro.
                        Successivamente l’evento è diventato nazionale, esportando l’esperienza in tutta Italia attraverso una call alla quale hanno partecipato
                    </p>
                    <p>
                        Nel 2022, 59 territori italiani in rappresentanza di oltre 150 comuni. I 2 borghi selezionati sono stati Bracciano (Roma) e Roseto Capo Spulico (Cs) dove si sono le tappe della VI edizione
                    </p>
                    <p>
                        Nel 2023, 73 territori italiani in rappresentanza di oltre 200 comuni. I 2 borghi saranno selezionati a breve.
                    </p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Informazioni</span>
                    <h2>Mettiti in contatto</h2>
                    <p>Ci piace ascoltare i lettori. Apprezziamo davvero che tu abbia dedicato del tempo per metterci in contatto.</p>
                    <ul>
                        <li>
                            <div class="icon">
                                <i class='bx bx-map'></i>
                            </div>
                            <h3>Dove siamo</h3>
                            <p>Corso Vittorio Emanuele II, 123<br>84014 Nocera Inferiore (SA)</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-phone-call'></i>
                            </div>
                            <h3>Contatti</h3>
                            <p>Mobile: <a href="tel:+393758232271">(+39) 375-8232271</a></p>
                            <p>@: <a href="mailto:segreteria@fondazioneampioraggio.it">segreteria@fondazioneampioraggio.it</a></p>
                        </li>
                        <li class="d-none">
                            <div class="icon">
                                <i class='bx bx-time-five'></i>
                            </div>
                            <h3>Siamo disponibili</h3>
                            <p>Lunedì-Venerdì: 9:00–13:00/14:00–19:00<br>Sabato: 9:00-13:00</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-form" *ngFor="let Image of bgImage;" style="background-image: url({{Image.img}});">
                    <h2>Come possiamo aiutarti?</h2>
                    <p>L'indirizzo email non verrà pubblicato. i campi richiesti sono contrassegnati dal simbolo*</p>
                    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name" placeholder="Nome e Cognome">
                                    <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                        <div *ngIf="name.errors.required">Nome e Cognome richiesto.</div>
                                        <div *ngIf="name.errors.minlength">Numero minimo {{ name.errors.minlength.requiredLength }} di caratteri.</div>
                                        <div *ngIf="name.errors.maxlength">Numero massimo di 50 caratteri.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required ngModel name="email" type="text" #email="ngModel" class="form-control" id="email" placeholder="la tua e-mail">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number" placeholder="cellulare">
                                    <div class="alert alert-danger" *ngIf="number.touched && !number.valid">un contatto telefonico è obbligatorio</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="5" class="form-control" placeholder="scrivi il tuo messaggio..."></textarea>
                                    <div class="alert alert-danger" *ngIf="message.touched && !name.valid">il messaggio è obbligatorio</div>
                                </div>
                            </div>
                            <h2 class="mt-3">Quale corso sei interessato?</h2>
                            <p>seleziona il corso interessato alla quale vuoi avere informazioni*</p>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <select name="sceltaCorso" ngModel id="sceltaCorso" #sceltaCorso="ngModel" style="display: block;
                                    width: 100%;
                                    border: none;
                                    color: var(--blackColor);
                                    background-color: #F3F6F9;
                                    height: 50px;
                                    padding-left: 15px;
                                    border-radius: 5px;
                                    font-size: var(--fontSize);
                                    font-weight: 600">
                                        <option value="{{elencoCorsiRow['corso']['titolo']}}" *ngFor="let elencoCorsiRow of elencoCorsi">{{elencoCorsiRow['corso']['titolo']}}</option>
                                      </select>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 mt-3">
                                <button type="submit" class="default-btn" [class.disabled]="!contactForm.valid">Invia Richiesta<span></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
